import colorsVars from 'styles/colors.module.scss';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/widgets/ProjectSummary/components/ToggleCollapse/ToggleCollapse.module.scss';

interface Props {
    collapse: boolean;
    setCollapse: (value: boolean) => void;
    id: string;
}

export const ToggleCollapse = ({ collapse, setCollapse, id }: Props) => {
    const title = collapse ? 'More' : 'Less';
    return (
        <div
            id={`${id}_collapse`}
            className={classes.collapseToggle}
            onClick={() => setCollapse(!collapse)}
            title={title}
        >
            <div className={`${classes.svgContainer} ${collapse && classes.isCollapse}`}>
                <MuiIcon icon={'keyboard_double_arrow_down'} color={colorsVars.linkColor} />
            </div>
        </div>
    );
};
